import { CustomField } from '@wix/bex-core';
import { CustomFieldsFormState } from '../../state';

export interface BaseInputProps<T> {
  dataHook?: string;
  state: CustomFieldsFormState;
  schema: CustomField;
  initialValue: T;
  onChange: (newValue: T) => void;
  inputRef?: (ref: BaseInputRef) => void;
}

export interface BaseInputRef {
  focus?: () => void;
  invalid?: boolean;
}
